import { render } from "./TextButton.vue?vue&type=template&id=b7fad706&scoped=true&bindings={}"
import script from "./TextButton.vue?vue&type=script&lang=ts"
export * from "./TextButton.vue?vue&type=script&lang=ts"

import "./TextButton.vue?vue&type=style&index=0&id=b7fad706&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b7fad706"

export default script